import { differenceInDays, parseISO } from 'date-fns';

export const hasMoreThanOneDayDifference = (firstDate?: string, secondDate?: string): boolean => {
  if (!firstDate || !secondDate) return false;
  const parsedFirstDate = parseISO(firstDate);
  const parsedSecondDate = parseISO(secondDate);
  const difference = differenceInDays(parsedFirstDate, parsedSecondDate);
  return difference >= 1;
};
